"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepContent = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../../utils/classify");
var _StepperModule = _interopRequireDefault(require("../Stepper.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StepContent = _ref => {
  let {
    children,
    classNames,
    active,
    completed = false,
    disabled = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_StepperModule.default.stepContentWrapper, {
      [_StepperModule.default.active]: active,
      [_StepperModule.default.completed]: completed,
      [_StepperModule.default.disabled]: disabled
    }, classNames?.wrapper)
  }, children);
};
exports.StepContent = StepContent;